module.exports = __webpack_public_path__ + "static/img/9a.9fca5c9d.png";